import React, { useState } from 'react';
import '../App.css'
import axios from 'axios';
import './feedbackButton.css'
import starRating from '../assets/starRating.svg'
import { ChakraProvider } from '@chakra-ui/react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Button,
    Textarea
} from '@chakra-ui/react'
import { useToast } from '@chakra-ui/react'
import StarRating from "../starRating/starRating";


const FeedbackLink = (props) => {
    const OverlayTwo = () => (
        <ModalOverlay
            bg='blackAlpha.300'
            backdropFilter='blur(10px) hue-rotate(90deg)'
        />
    )
    const SERVER_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5000/' : '/api/';
    const FEEDBACK_SERVER_URL = SERVER_URL + 'submit-feedback';
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [overlay, setOverlay] = React.useState(<OverlayTwo />)

    const [rating, setRating] = useState(5);
    const [feedback, setFeedback] = useState('');
    const [error, setError] = useState(null); // Handle error state
    const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);

    const toast = useToast({ position: 'top-right' });

    const handleChange = (event) => {
        setFeedback(event.target.value);
    };

    const handleSubmit = async () => {
        // Handle the feedback submission logic
        if (!rating) {
            return;
        }

        try {
            let feedback_body = {
                UserEmail: localStorage.getItem('userinfo'),
                Rating: rating,
                Feedback: feedback,
            }
            let response = await axios.post(FEEDBACK_SERVER_URL, feedback_body);

            if (response.data.valid) {
                setFeedbackSubmitted(true);
                setTimeout(() => {
                    setFeedbackSubmitted(false);
                    setFeedback('');
                    setRating(5);
                    onClose();
                }, 2000);
            } else {
                toast({
                    title: props.translate('Submission failed'),
                    description: props.translate('Something went wrong. Please try again.'),
                    status: 'error',
                    duration: 2000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast({
                title: props.translate('Submission failed'),
                description: props.translate('Something went wrong. Please try again.'),
                status: 'error',
                duration: 2000,
                isClosable: true,
            });
            setError(error);
        }
    };

    return (
        <>
            <button
                className="start-new-btn"
                style={{ fontSize: props.langOpt === 'Japanese' ? '14px' : '14px', fontWeight: '400' }}
                onClick={() => {
                    setOverlay(<OverlayTwo />);
                    onOpen();
                }}
            >
                <img src="./feedback.svg" alt="feedbackIcon" />
                <span className="btn-text">{props.translate("Submit Feedback")}</span>
            </button>

            <ChakraProvider resetCSS={false}>
                <Modal isCentered isOpen={isOpen} onClose={onClose}>
                    {overlay}
                    <ModalContent>
                        <ModalCloseButton />
                        {!feedbackSubmitted ? (
                            <>
                                <ModalBody>
                                    <h2 className="feedback-title">{props.translate("Help us shape a better experience by sharing your feedback!")}</h2>
                                    <StarRating rating={rating} setRating={setRating} />
                                    <Textarea className='feedInputBox' placeholder={props.translate("Enter your feedback")} onChange={handleChange} value={feedback}></Textarea>
                                </ModalBody>
                                <ModalFooter>
                                    <Button className='closeBtnDTC' onClick={onClose} mr={3} >{props.translate('Close')}</Button>
                                    <Button
                                        className={feedback.trim() ? 'submitBtnDTC active' : 'submitBtnDTC'}
                                        colorScheme='blue'
                                        onClick={() => handleSubmit()}
                                        isDisabled={!feedback.trim()}
                                    >
                                        {props.translate('Submit')}
                                    </Button>
                                </ModalFooter>
                            </>
                        ) : (
                            <ModalBody className="feedback-success">
                                <div className="success-icon">
                                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                                        <circle cx="32" cy="32" r="32" fill="#00AA44" />
                                        <path d="M20 32L28 40L44 24" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h2 className="success-title">{props.translate('Thank You!')}</h2>
                                <p className="success-message">{props.translate('Your feedback was successfully submitted.')}</p>
                            </ModalBody>
                        )}
                    </ModalContent>
                </Modal>
            </ChakraProvider>
        </>
    );
};

export default FeedbackLink;